// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1sjGF","label":"Category_label__beMPM","content":"Category_content__11nUw","header":"Category_header__2T3gW","location":"Category_location__3qB5F"};